(function(){
  function init(root){

    if (!root || root.dataset.whlV20Ready === 'true') return;
    root.dataset.whlV20Ready = 'true';

    var downloadDataNode = root.querySelector('[data-whl-download-data]');
    var downloadData = {};
    try { downloadData = downloadDataNode ? JSON.parse(downloadDataNode.textContent) : {}; } catch (error) {}

    var deliveryDataNode = root.querySelector('[data-whl-delivery-data]');
    var deliveryData = {};
    try { deliveryData = deliveryDataNode ? JSON.parse(deliveryDataNode.textContent) : {}; } catch (error) {}

    function whlMoney(cents) {
      var value = Number(cents || 0) / 100;
      var iso = deliveryData.currency || 'ZAR';
      try {
        return new Intl.NumberFormat('en-ZA', {
          style: 'currency',
          currency: iso,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(value);
      } catch (error) {
        return 'R ' + value.toFixed(2);
      }
    }

    function whlCurrentVariantPrice() {
      var hidden = root.querySelector('.product-variant-id');
      var selectedId = hidden ? String(hidden.value || '') : '';
      var variants = Array.isArray(deliveryData.variants) ? deliveryData.variants : [];
      var match = variants.find(function (variant) { return String(variant.id) === selectedId; });
      if (match) return Number(match.price || 0);

      var fallbackId = String(deliveryData.selectedVariantId || '');
      var fallback = variants.find(function (variant) { return String(variant.id) === String(fallbackId); });
      return fallback ? Number(fallback.price || 0) : 0;
    }

    function currentVariantData() {
      var hidden = root.querySelector('.product-variant-id');
      var selectedId = hidden ? String(hidden.value || '') : String(deliveryData.selectedVariantId || '');
      var variants = Array.isArray(deliveryData.variants) ? deliveryData.variants : [];
      return variants.find(function (variant) { return String(variant.id) === selectedId; }) || variants[0] || null;
    }

    function updateStockDisplay() {
      var card = root.querySelector('[data-whl-stock-display]');
      var text = root.querySelector('[data-whl-stock-text]');
      var dot = root.querySelector('[data-whl-stock-dot]');
      var variant = currentVariantData();
      if (!card || !text || !dot || !variant) return;

      dot.classList.remove('whl-stock-dot--in','whl-stock-dot--order','whl-stock-dot--out');
      if (variant.inventoryManagement) {
        if (Number(variant.inventoryQuantity || 0) > 0) {
          dot.classList.add('whl-stock-dot--in');
          text.textContent = Number(variant.inventoryQuantity) + ' in stock';
        } else if (variant.inventoryPolicy === 'continue') {
          dot.classList.add('whl-stock-dot--order');
          text.textContent = 'Available to order';
        } else {
          dot.classList.add('whl-stock-dot--out');
          text.textContent = 'Out of stock';
        }
      } else if (variant.available) {
        dot.classList.add('whl-stock-dot--in');
        text.textContent = 'In stock';
      } else {
        dot.classList.add('whl-stock-dot--out');
        text.textContent = 'Out of stock';
      }
    }

    function updateFreeDeliveryProgress() {
      if (!deliveryData || deliveryData.requiresQuote) return;

      var progress = root.querySelector('[data-whl-free-delivery-progress]');
      var main = root.querySelector('[data-whl-delivery-main]');
      var prefix = root.querySelector('[data-whl-free-delivery-prefix]');
      var amount = root.querySelector('[data-whl-free-delivery-amount]');
      var suffix = root.querySelector('[data-whl-free-delivery-suffix]');
      if (!progress || !main || !prefix || !amount || !suffix) return;

      var qtyInput = root.querySelector('input.quantity__input');
      var qty = Math.max(1, Number(qtyInput && qtyInput.value ? qtyInput.value : 1));
      var unitPrice = whlCurrentVariantPrice();
      var projectedOrder = Number(deliveryData.cartTotal || 0) + (unitPrice * qty);
      var threshold = Number(deliveryData.freeThreshold || 0);
      var remaining = Math.max(0, threshold - projectedOrder);

      if (threshold > 0 && remaining <= 0) {
        main.textContent = 'Free Standard Delivery 🇿🇦';
        prefix.textContent = 'Free Standard Delivery unlocked';
        amount.textContent = '';
        suffix.textContent = '';
        progress.classList.add('is-unlocked');
      } else {
        main.textContent = whlMoney(deliveryData.standardFee || 0) + ' Standard Delivery 🇿🇦';
        prefix.textContent = 'Spend';
        amount.textContent = whlMoney(remaining);
        suffix.textContent = 'more to unlock Free Standard Delivery';
        progress.classList.remove('is-unlocked');
      }
    }

    function toast(message) {
      var holder = root.querySelector('.whl-toast-holder');
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'whl-toast-holder';
        root.appendChild(holder);
      }
      var item = document.createElement('div');
      item.className = 'whl-toast';
      item.textContent = message;
      holder.appendChild(item);
      requestAnimationFrame(function () { item.classList.add('is-visible'); });
      window.setTimeout(function () {
        item.classList.remove('is-visible');
        window.setTimeout(function () { item.remove(); }, 250);
      }, 2300);
    }

    function productUrl() { return window.location.href; }
    function productTitle() { return downloadData.title || document.title; }
    function productPrice() { return downloadData.price || ''; }
    function shareText() {
      return [productTitle(), productPrice(), 'Whitehouse Lighting & Electrical', productUrl()].filter(Boolean).join(' • ');
    }
    function openPopup(url) { window.open(url, '_blank', 'noopener,noreferrer,width=760,height=760'); }

    /* Image-copy deterrent. Public web images can never be made technically impossible to capture. */
    function isProductMedia(target) { return target && target.closest('.product__media, .product-media-container, .thumbnail'); }
    ['dragstart', 'copy', 'cut'].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) {
        if (!isProductMedia(event.target)) return;
        event.preventDefault();
        toast('Forbidden: product images cannot be copied from this page.');
      });
    });
    root.addEventListener('contextmenu', function (event) {
      if (!isProductMedia(event.target)) return;
      event.preventDefault();
      toast('Forbidden: product images cannot be copied from this page.');
    });

    /* Stable Buy Now: uses the currently selected variant and the visible quantity,
       then proceeds to checkout. It does not depend on Shopify's accelerated-payment
       button rendering, which keeps the Whitehouse two-button layout consistent. */
    async function whlBuyNow(button) {
      if (!button || button.disabled) return;
      var purchase = button.closest('.whl-ordered-buy-actions');
      var variantInput = purchase && purchase.querySelector('input.product-variant-id[name="id"]');
      var quantityInput = root.querySelector('input.quantity__input');
      var addButton = purchase && purchase.querySelector('.product-form__submit');
      var variantId = variantInput && !variantInput.disabled ? Number(variantInput.value) : 0;
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value ? quantityInput.value : 1) || 1);
      if (!variantId || (addButton && addButton.disabled)) {
        toast('Please choose an available product option first.');
        return;
      }

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Preparing checkout…';
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        });
        if (!response.ok) throw new Error('Unable to add selected variant');
        window.location.assign('/checkout');
      } catch (error) {
        button.disabled = false;
        button.textContent = original;
        toast('Unable to start checkout. Please use Add to Cart or try again.');
      }
    }

    root.addEventListener('click', function (event) {
      var buyNow = event.target.closest('[data-whl-buy-now]');
      if (!buyNow) return;
      event.preventDefault();
      whlBuyNow(buyNow);
    });

    function syncWhlBuyNow() {
      var purchase = root.querySelector('.whl-ordered-buy-actions');
      if (!purchase) return;
      var buyNow = purchase.querySelector('[data-whl-buy-now]');
      var addButton = purchase.querySelector('.product-form__submit');
      var variantInput = purchase.querySelector('input.product-variant-id[name="id"]');
      if (!buyNow) return;
      buyNow.disabled = !variantInput || variantInput.disabled || !variantInput.value || (addButton && addButton.disabled);
    }

    var purchaseObserverTarget = root.querySelector('.whl-ordered-buy-actions');
    if (purchaseObserverTarget && window.MutationObserver) {
      var purchaseObserver = new MutationObserver(syncWhlBuyNow);
      purchaseObserver.observe(purchaseObserverTarget, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    root.addEventListener('change', function () { window.setTimeout(syncWhlBuyNow, 0); });
    syncWhlBuyNow();

    /* Inventory guard. */
    root.addEventListener('input', function (event) {
      var input = event.target.closest('input.quantity__input[data-whl-stock-limited="true"]');
      if (!input) return;
      var max = input.max === '' ? null : Number(input.max);
      var min = input.min === '' ? 1 : Number(input.min);
      var value = Number(input.value || min);
      if (max !== null && Number.isFinite(max) && value > max) input.value = max;
      if (Number.isFinite(min) && value < min) input.value = min;
    });
    root.addEventListener('click', function (event) {
      var button = event.target.closest('.quantity__button');
      if (!button) return;
      var quantity = button.closest('quantity-input');
      var input = quantity && quantity.querySelector('input.quantity__input[data-whl-stock-limited="true"]');
      if (!input) return;
      var max = input.max === '' ? null : Number(input.max);
      if (button.name === 'plus' && max !== null && Number(input.value || 0) >= max) {
        event.preventDefault();
        event.stopPropagation();
        input.value = max;
        toast('Maximum available stock reached.');
      }
    }, true);

    /* V17 delivery threshold progress: updates with quantity and selected variant. */
    root.addEventListener('input', function (event) {
      if (event.target.matches('input.quantity__input')) updateFreeDeliveryProgress();
    });
    root.addEventListener('change', function () {
      window.setTimeout(updateFreeDeliveryProgress, 0);
      window.setTimeout(updateFreeDeliveryProgress, 80);
      window.setTimeout(updateStockDisplay, 80);
    });

    var whlPriceNode = root.querySelector('[id^="price-"]');
    if (whlPriceNode && 'MutationObserver' in window) {
      new MutationObserver(function () {
        window.setTimeout(updateFreeDeliveryProgress, 0);
      }).observe(whlPriceNode, { childList: true, subtree: true, characterData: true });
    }
    updateFreeDeliveryProgress();
    updateStockDisplay();

    /* Compact FAQ: keep only one answer open at a time. */
    var whlFaqItems = root.querySelectorAll('.whl-product-faq__item');
    whlFaqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        whlFaqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    function normalizeLabel(value) {
      return String(value || '').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim();
    }

    function canonicalSpecLabel(value) {
      var key = normalizeLabel(value);
      if (key === 'sku model' || key === 'mpn model') return 'model';
      if (key === 'colour finish' || key === 'color finish') return 'colour';
      if (key === 'power' || key === 'wattage power') return 'wattage power';
      if (key === 'lumen output' || key === 'luminous flux') return 'lumens';
      if (key === 'size length') return 'dimensions';
      return key;
    }

    function enhanceDescription() {
      var content = root.querySelector('.whl-product-details__content');
      if (!content) return;

      var first = content.firstElementChild;
      if (first && first.tagName === 'P' && normalizeLabel(first.textContent) === normalizeLabel(productTitle())) first.hidden = true;

      var specGrid = root.querySelector('.whl-product-panel--specs .whl-spec-grid');
      var specPanel = root.querySelector('.whl-product-panel--specs');
      var existing = new Set();
      if (specGrid) {
        specGrid.querySelectorAll('.whl-spec dt').forEach(function (dt) { existing.add(canonicalSpecLabel(dt.textContent)); });
      }

      Array.from(content.children).forEach(function (node) {
        var text = String(node.textContent || '').trim().replace(/:$/, '');
        var isStandaloneStrong = node.tagName === 'P' && node.children.length === 1 && node.firstElementChild && node.firstElementChild.tagName === 'STRONG';
        if (!isStandaloneStrong) return;

        if (/^features$/i.test(text)) {
          node.classList.add('whl-description-subhead');
          var list = node.nextElementSibling;
          if (list && (list.tagName === 'UL' || list.tagName === 'OL')) list.classList.add('whl-description-list--features');
          return;
        }

        if (/^specifications?$/i.test(text)) {
          node.classList.add('whl-description-subhead');
          var specs = node.nextElementSibling;
          var copied = 0;
          if (specs && (specs.tagName === 'UL' || specs.tagName === 'OL')) {
            specs.classList.add('whl-description-list--specs');
            if (specGrid) {
              Array.from(specs.querySelectorAll('li')).forEach(function (li) {
                var raw = String(li.textContent || '').trim();
                var colon = raw.indexOf(':');
                if (colon < 1) return;
                var label = raw.slice(0, colon).trim();
                var value = raw.slice(colon + 1).trim();
                if (!label || !value || normalizeLabel(label) === 'brand') return;
                var canonical = canonicalSpecLabel(label);
                if (existing.has(canonical)) return;
                existing.add(canonical);
                var row = document.createElement('div');
                row.className = 'whl-spec whl-spec--listing';
                var dt = document.createElement('dt');
                var dd = document.createElement('dd');
                dt.textContent = label;
                dd.textContent = value;
                row.appendChild(dt); row.appendChild(dd); specGrid.appendChild(row); copied += 1;
              });
            }
            if (copied >= 2 && specPanel) {
              node.classList.add('is-moved-to-panel');
              specs.classList.add('is-moved-to-panel');
              var link = document.createElement('a');
              link.href = '#' + (specPanel.getAttribute('aria-labelledby') || '');
              link.className = 'whl-description-specs-link';
              link.textContent = 'View specifications →';
              node.insertAdjacentElement('afterend', link);
            }
          }
          return;
        }

        if (/^what'?s in the box$/i.test(text) || /^what is in the box$/i.test(text)) {
          node.classList.add('whl-description-subhead');
          var box = node.nextElementSibling;
          if (box) box.classList.add('whl-description-box');
        }
      });
    }

    enhanceDescription();

    /* Product gallery is intentionally static in V12.
       Customers change images manually using the thumbnails.
       A fixed gallery stage prevents page jumping. */


    /* Compact social-share controls. */
    var pinterestPicker = root.querySelector('[data-whl-pinterest-picker]');
    var pinterestClose = root.querySelector('[data-whl-pin-close]');
    function closePinterestPicker() { if (pinterestPicker) pinterestPicker.hidden = true; }
    function openPinterestPicker() { if (pinterestPicker) pinterestPicker.hidden = false; }
    if (pinterestClose) pinterestClose.addEventListener('click', closePinterestPicker);
    if (pinterestPicker) pinterestPicker.addEventListener('click', function (event) { if (event.target === pinterestPicker) closePinterestPicker(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closePinterestPicker(); });

    root.querySelectorAll('.whl-share-option').forEach(function (button) {
      button.addEventListener('click', async function () {
        var platform = button.getAttribute('data-platform');
        var encodedUrl = encodeURIComponent(productUrl());
        var encodedText = encodeURIComponent(shareText());
        var encodedTitle = encodeURIComponent(productTitle());

        if (platform === 'copy') {
          try { await navigator.clipboard.writeText(productUrl()); toast('Product link copied.'); } catch (error) { toast('Unable to copy the link on this device.'); }
          return;
        }
        if (platform === 'native') {
          try {
            if (navigator.share) await navigator.share({ title: productTitle(), text: shareText(), url: productUrl() });
            else { await navigator.clipboard.writeText(productUrl()); toast('Product link copied.'); }
          } catch (error) {}
          return;
        }
        if (platform === 'whatsapp') { openPopup('https://api.whatsapp.com/send?text=' + encodedText); return; }
        if (platform === 'facebook') { openPopup('https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl); return; }
        if (platform === 'x') { openPopup('https://twitter.com/intent/tweet?text=' + encodedText + '&url=' + encodedUrl); return; }
        if (platform === 'email') { window.location.href = 'mailto:?subject=' + encodedTitle + '&body=' + encodedText; return; }
        if (platform === 'pinterest-picker') { openPinterestPicker(); return; }
        if (platform === 'instagram-card') { shareInstagramCard(); return; }
      });
    });
    root.querySelectorAll('.whl-pinterest-choice').forEach(function (button) {
      button.addEventListener('click', function () {
        var media = encodeURIComponent(button.getAttribute('data-whl-pin-media') || '');
        var url = encodeURIComponent(button.getAttribute('data-whl-pin-url') || productUrl());
        var description = encodeURIComponent(button.getAttribute('data-whl-pin-description') || productTitle());
        openPopup('https://www.pinterest.com/pin/create/button/?url=' + url + '&media=' + media + '&description=' + description);
        closePinterestPicker();
      });
    });

    async function createAdvertisingCard(instagramMode) {
      if (!window.WHLProductCardV20 || typeof window.WHLProductCardV20.create !== 'function') {
        throw new Error('Whitehouse Product Card Studio V20 did not load.');
      }

      return window.WHLProductCardV20.create({
        root: root,
        data: downloadData,
        instagramMode: instagramMode === true,
        title: productTitle(),
        price: productPrice(),
        url: productUrl()
      });
    }

    function downloadBlob(blob, suffix) {
      if (!blob) return;
      var link=document.createElement('a');
      link.href=URL.createObjectURL(blob);
      link.download=(productTitle() || 'whitehouse-product').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') + suffix;
      document.body.appendChild(link); link.click(); link.remove(); window.setTimeout(function(){URL.revokeObjectURL(link.href);},500);
    }

    async function shareInstagramCard() {
      var blob=await createAdvertisingCard(true);
      if (!blob) return;
      var file=new File([blob], 'whitehouse-product.png', {type:'image/png'});
      var caption=productTitle() + (productPrice() ? ' — ' + productPrice() : '') + '\n' + productUrl();
      try {
        if (navigator.canShare && navigator.canShare({files:[file]}) && navigator.share) {
          await navigator.share({files:[file], title:productTitle(), text:caption});
          return;
        }
      } catch (error) {}
      downloadBlob(blob,'-instagram-card.png');
      try { await navigator.clipboard.writeText(caption); toast('Instagram-ready card downloaded and caption copied.'); }
      catch (error) { toast('Instagram-ready card downloaded.'); }
    }

    root.querySelectorAll('[data-whl-product-download]').forEach(function (button) {
      button.addEventListener('click', async function () {
        button.disabled=true;
        var label=button.querySelector('span');
        var old=label ? label.textContent : '';
        if (label) label.textContent='Building card…';
        try {
          var blob=await createAdvertisingCard(false);
          downloadBlob(blob,'-product-card.png');
          toast('Professional product card downloaded.');
        } finally {
          button.disabled=false;
          if (label) label.textContent=old;
        }
      });
    });
  
  }
  function boot(scope){
    (scope || document).querySelectorAll('[data-whl-main-product]').forEach(init);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function(event){ boot(event.target); });
})();
